import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { getControlCenterOrigin } from 'utils/getControlCenterOrigin';
import { mfaManagementRoute } from 'routes/constants';
import { setWindowLocation } from 'utils/setWindowLocation';

import { useMfaSetupStatus } from './useMfaSetupStatus';

export const useHandleNeedsMfa = () => {
  const location = useLocation();
  const { needsMfaSetup, isLoading } = useMfaSetupStatus();

  useEffect(() => {
    // Wait for data to load before checking
    if (isLoading) return;

    // Don't redirect if already on mfaManagement page
    if (location.pathname.includes('mfaManagement')) return;

    if (needsMfaSetup) {
      const ccDomain = getControlCenterOrigin();
      setWindowLocation(
        `${ccDomain}${mfaManagementRoute}${location.search ?? ''}`,
      );
    }
  }, [isLoading, needsMfaSetup, location.pathname, location.search]);
};
